import type { IconData } from '@stacksjs/iconify-core'

export const voicemail: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M9.743 9h4.514A5.5 5.5 0 1 1 19 10.978V11H6v-.022A5.5 5.5 0 1 1 9.743 9M5.5 9a3.5 3.5 0 1 0 0-7a3.5 3.5 0 0 0 0 7m13 0a3.5 3.5 0 1 0 0-7a3.5 3.5 0 0 0 0 7\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default voicemail
